import React from 'react';

interface StepManagerProps {
    step: number;
    steps: { component: JSX.Element }[];
}

const StepManager: React.FC<StepManagerProps> = ({ step, steps }) => {
    const StepComponent = steps[step - 1]?.component;
    return StepComponent ?? null;
};

export default StepManager;
